export const iconFontAwesomeEditingPenNib = (
	<i className="fa-solid fa-pen-nib"></i>
);
